import { Path } from '@/main/router/routerPath';
import { RozmerPneuDisku } from '@/modules/ciselnik/pneu/rozmerPneuDisku';
import { SirkaDisku } from '@/modules/ciselnik/pneu/sirkaDisku';
import { SirkaPneu } from '@/modules/ciselnik/pneu/sirkaPneu';
import { SkladPneu } from '@/modules/ciselnik/pneu/skladPneu';
import { SkladoveMistoPneu } from '@/modules/ciselnik/pneu/skladoveMistoPneu';
import { TypPneu } from '@/modules/ciselnik/pneu/typPneu';
import { VyrobcePneu } from '@/modules/ciselnik/pneu/vyrobcePneu';
import { VyrobceDisku } from '@/modules/ciselnik/pneu/vyrobceDisku';
import { VyskaPneu } from '@/modules/ciselnik/pneu/vyskaPneu';

export const router = new Path('Pneu').addChildren([
	RozmerPneuDisku.router,
	SirkaDisku.router,
	SirkaPneu.router,
	SkladPneu.router,
	SkladoveMistoPneu.router,
	TypPneu.router,
	VyrobcePneu.router,
	VyrobceDisku.router,
	VyskaPneu.router,
]);
